import { apiClient } from '@isocel/front-common';

import { BaseModel } from './types';

export const fetchParcPalette = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/parcsPalette`);
    return (data as any[])
        .map((p) => ({ ...p, id: p.id || p._id } as BaseModel))
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
};

export const fetchProvider = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/providers`);
    return data.sort((a: BaseModel, b: BaseModel) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
};
